// i18n area 'common' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.bg-BG.meta.json.
import type { enUS } from './common'

export const bgBG: typeof enUS = {
  nav: {
    home: 'Начало',
    vms: 'Виртуални машини',
    templates: 'Шаблони',
    importVms: 'Импорт на ВМ',
    containers: 'Контейнери',
    containersApps: 'Приложения',
    containersPods: 'Подове',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI образи',
    containersOciRegistries: 'OCI регистри',
    containersCtTemplates: 'CT шаблони',
    networkServices: 'Мрежови услуги',
    firewall: 'Защитна стена',
    checkpoints: 'Чекпойнти',
    backup: 'Резервно копиране',
    monitoring: 'Мониторинг',
    cluster: 'Клъстер',
    clusterSettings: 'Глобални настройки',
    clusterNodes: 'Възли',
    clusterDevices: 'USB и PCIe ресурси',
    clusterFederation: 'Федерация',
    network: 'Мрежа',
    overlayNetworks: 'Оверлейни мрежи',
    fabric: 'Фабрика',
    ipam: 'IPAM',
    storage: 'Хранилище',
    data: 'Данни',
    storages: 'Хранилища',
    hci: 'Хиперконвергенция',
    ceph: 'Ceph',
    system: 'Система',
    tasks: 'Задачи',
    events: 'Събития',
    audit: 'Одит',
    diagnostics: 'Диагностика',
    notifications: 'Известия',
    proximity: 'TVirt Proximity',
    users: 'Потребители и групи',
    groups: 'Групи',
    mfa: 'MFA',
    realms: 'Реалми и SSO',
    rbac: 'Роли и права',
    credentials: 'Идентификационни данни',
    scopes: 'Скоупове',
    tags: 'Тагове',
    explorer: 'Разглеждане',
    licensing: 'Лиценз',
    information: 'Информация'
  },
  mode: {
    light: 'Светла',
    dark: 'Тъмна',
    system: 'Системна',
    tooltip: 'Тема'
  },
  language: {
    tooltip: 'Език'
  },
  langRegion: {
    europe: 'Европа',
    northAmerica: 'Северна Америка',
    southAmerica: 'Южна Америка',
    asia: 'Азия'
  },
  notFound: {
    title: 'Страницата не е намерена',
    body: 'Този адрес не съответства на нито една страница на TVirt — може да се е преместила с обновление или връзката е остаряла.',
    backHome: 'Обратно към Начало'
  },
  scopeBrowser: {
    title: 'Скоупове',
    all: 'Целият клъстер',
    noChildren: 'Тук няма под-скоупове',
    recursive: 'Включи наследниците',
    collapse: 'Свий панела със скоупове',
    openPicker: 'Разгледай скоуповете',
    up: 'Едно ниво нагоре',
    countTooltip: '{direct} в този скоуп · {total} с наследниците'
  },
  search: {
    tooltip: 'Търсене (⌘K)',
    placeholder: 'Търси ВМ, мрежи, хранилища…',
    empty: 'Няма съвпадения',
    groups: {
      recent: 'Скорошни',
      shortcuts: 'Преки пътища',
      actions: 'Действия',
      goTo: 'Отиди на'
    },
    kind: {
      catalog: 'Каталог',
      scope: 'Скоуп',
      node: 'Възел'
    },
    footer: {
      navigate: 'навигация',
      open: 'отваряне',
      close: 'затваряне'
    },
    actions: {
      createVm: 'Създай ВМ…',
      uploadIso: 'Качи ISO…',
      clusterSettings: 'Настройки на клъстера',
      consoleOf: 'Отиди на конзолата на {name}'
    }
  },
  stub: {
    containersSummary: 'Приложения и системни контейнери (CT), с техните OCI образи, регистри и шаблони — управлявани редом с вашите ВМ.',
    sectionSummary_vms: 'Виртуални машини и техните шаблони — жизнен цикъл, снапшоти, миграция и конзоли.',
    sectionSummary_storages: 'Хранилищата, в които живеят дисковете, образите и метаданните на ВМ.',
    sectionSummary_catalogs: 'Домът на файловите артефакти на клъстера: ISO образи, шаблони за CT и ВМ и OCI архиви, подредени в каталози.',
    sectionSummary_overlay: 'VXLAN оверлейни мрежи между възлите на клъстера.',
    sectionSummary_fabric: 'Инвентарът на физическата мрежа — комутатори, портове, LAGG и логически мрежи.',
    sectionSummary_ipam: 'Адресирането, изведено от мрежите на фабриката и оверлея: кой държи всеки адрес.',
    sectionSummary_services: 'DHCP и DNS сървъри, изведени от мрежовия регистър.',
    sectionSummary_ceph: 'Управлявани Ceph клъстери върху възлите на TVirt.',
    sectionSummary_hci: 'Хиперконвергентните технологии за съхранение върху възлите на TVirt.',
    sectionSummary_cluster: 'Възли, членство и настройки на ниво клъстер.',
    containers: 'Системните контейнери са в пътната карта — този раздел ще ги приюти.',
    containersApps: 'Контейнеризираните приложения са в пътната карта — тази област ще ги приюти.',
    containersPods: 'Подовете групират контейнери, споделящи мрежа и томове — инстанциите са приложенията.',
    containersCt: 'Системните контейнери (CT) са в пътната карта — тази област ще ги приюти.',
    multiscsi: 'TVStor MultiSCSI е в пътната карта — тази област ще го приюти.',
    clusterFederation: 'Федерацията между TVirt клъстери е в пътната карта — тази област ще я приюти.',
    containersOciImages: 'OCI образите са в пътната карта — тази област ще ги приюти.',
    containersOciRegistries: 'OCI регистрите са в пътната карта — тази област ще ги приюти.',
    containersCtTemplates: 'CT шаблоните са в пътната карта — тази област ще ги приюти.',
    importVms: 'Тук ще пристигнат импортерите за ESXi и Proxmox: конвертиране на гостите и масова миграция към TVirt.',
    backup: 'Интегрираното резервно копиране идва с 6.2: дедуплицирани content-addressed репозитории, CBT инкременти, прозорци на неизменимост и репликация repo-to-repo.',
    monitoring: 'Таблата за конкуренция на ниво клъстер (cpu.ready, PSI налягане, вградени аларми) са на път — днес същите метрики живеят в детайлите на всяка ВМ.'
  },
  home: {
    welcome: 'Влезли сте като: {name}',
    subtitle: 'Ето вашия TVirt клъстер с един поглед.',
    loadError: 'Неуспешно зареждане на прегледа — достъпен ли е бекендът на TVirt?',
    health: {
      ok: 'Всичко е наред',
      warning: 'Нужно е внимание',
      critical: 'Критични проблеми'
    },
    reason: {
      'node-down': '{subject} е изключен',
      'node-stale': '{subject} не се е обаждал скоро',
      'node-maintenance': '{subject} е в поддръжка',
      'tasks-failed': {
        one: '{n} провалена задача през последните 24 ч',
        other: '{n} провалени задачи през последните 24 ч'
      },
      'storage-degraded': 'хранилището {subject} е деградирало',
      'storage-error': 'хранилището {subject} е в грешка',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'хранилището на конфигурацията е недостъпно',
      'license-absent': 'няма лиценз — нови ВМ не могат да стартират',
      'license-expired': 'лицензът е изтекъл — нови ВМ не могат да стартират',
      'license-exceeded': 'лимитът на лиценза е надвишен — нови ВМ не могат да стартират',
      'failover-reserve-eroded': 'резервът за аварийно превключване е почти изчерпан',
      'failover-reserve-exhausted': 'резервът за аварийно превключване е изчерпан — нови ВМ не могат да стартират',

      'oci-cache-nearly-full': 'OCI кешът на {subject} е почти пълен — дайджестите се изхвърлят ръчно',
      'oci-cache-full': 'OCI кешът на {subject} е пълен — никой pull няма да успее, докато не изхвърлите дайджести',
      'config-replica-empty': 'репликата на конфигурацията на {subject} е ПРАЗНА — възелът няма клъстерна конфигурация, докато една репликация не успее',
      'config-replica-stalled': 'репликацията на конфигурацията на {subject} е спряла — локалното копие изостава от конфигурацията на клъстера'
    },
    staleChip: 'Данните не са актуални',
    staleAsOf: 'последна реплика {time}',
    zone: {
      nodes: 'Възли',
      failoverReserve: 'Резерв за аварийно превключване',
      capacity: 'Капацитет',
      workload: 'Работно натоварване',
      protection: 'Защита',
      activity: 'Скорошна активност'
    },
    reserve: {
      state: {
        ok: 'Резервът е непокътнат',
        eroded: 'Резервът е почти изчерпан',
        exhausted: 'Резервът е изчерпан',
        unknown: 'Резервът е неизвестен'
      },
      tolerate: {
        one: 'издържа загубата на {n} възел',
        other: 'издържа загубата на {n} възела'
      },
      usedOf: '{used} / {allowed} GiB в употреба',
      keepFree: '{n} GiB пазени свободни за аварийно превключване',
      expendable: 'от които {n} могат да се пожертват в работен режим',
      headroom: 'могат да се стартират още {n} GiB',
      short: 'на резерва липсват {n} GiB — нови ВМ не могат да стартират',
      hp: {
        usedOf: 'Страници по {size} — в употреба: {used} / {allowed}',
        keepFree: 'пазени свободни за аварийно превключване: {keep}',
        headroom: 'могат още да се стартират: {n}',
        short: 'липсващи на резерва: {n} — нови ВМ с огромни страници не могат да стартират'
      },
      worstCase: 'най-лош случай: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Никой възел още не е декларирал паметта си — резервът не може да се изчисли и никой старт не се отказва.',
      reason: {
        attestedDown: 'атестиран като изключен',
        maintenance: 'в поддръжка',
        unreachable: 'недостъпен',
        capacityUnknown: 'паметта не е декларирана'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} ядра / {threads} нишки',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} активна ВМ',
        other: '{n} активни ВМ'
      },
      activeVmsUnknown: 'активните ВМ са неизвестни',
      lastSeen: 'видян {time}',
      neverSeen: 'никога не е виждан',
      down: 'Изключен',
      maintenance: 'Поддръжка',
      stale: 'Недостъпен'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB провизирани',
      reserve: 'резерв {n} GiB',
      unobserved: 'капацитетът още не е наблюдаван',
      empty: 'Още няма хранилища'
    },
    workload: {
      vms: 'Виртуални машини',
      apps: 'Приложения',
      services: 'Мрежови услуги',
      empty: 'Още няма',
      phasesUnknown: 'разбивката по фази не е налична'
    },
    protection: {
      none: 'Още няма конфигурирана дестинация за бекъп — защитете конфигурацията си.',
      configure: 'Конфигурирай чекпойнтите',
      noRuns: 'Още не е създаден нито един чекпойнт.',
      last: 'Последен чекпойнт',
      onTarget: 'на {target}',
      viewAll: 'Чекпойнти'
    },
    activity: {
      empty: 'Няма скорошна активност',
      failed24: {
        one: '{n} провалена за 24 ч',
        other: '{n} провалени за 24 ч'
      },
      viewAll: 'Виж всички задачи'
    }
  },
  notes: {
    title: 'Бележки',
    tabEdit: 'Редактиране',
    tabPreview: 'Преглед',
    placeholder: 'Свободни бележки на оператора — Markdown се визуализира в прегледа',
    empty: 'Няма бележки',
    tooLarge: 'Бележките надхвърлят лимита от 64 KiB',
    saveError: 'Неуспешно запазване на бележките'
  },
  common: {
    contractError: 'Отговорът на бекенда съдържа стойност, която този интерфейс не познава: {field}={value} — обновете уеб интерфейса до версията на бекенда.',
    contractErrorItems: '{count} обекта от този списък не могат да бъдат прочетени от този интерфейс ({field}={value}) и не се показват.',
    staleHint: 'Хранилището на конфигурацията е недостъпно — това е конфигурационната реплика на този възел; състоянието на флота е неизвестно.',
    staleStateAge: 'състояние към {time}',
    staleStateNever: 'състоянието никога не е получавано от хранилището: виждате само наблюденията на този възел',
    staleStateTooltip: 'Хранилището на клъстера е недостъпно: наблюдаваното състояние (фаза, възел, агент) идва от репликата на състоянието на този възел и датира от последното успешно четене от хранилището — може да е остаряло.',
    noPermission: 'Нямате право за това действие',
    actionStillRunning: 'Действието още тече — резултатът му още не е известен',
    staleWrite: 'Някой друг промени този обект, докато го редактирахте — нищо не беше записано. Презаредете и повторете промяната върху актуалното състояние.',
    staleReload: 'Презареди',
    preview: 'Преглед',
    previewTitle: 'Преглед на резултата',
    previewNothingWritten: 'Симулирано на сървъра — нищо не е записано.',
    previewChanged: 'Откроени са стойностите, които биха се променили.'
  },
  context: {
    copySelection: 'Копирай избрания текст'
  },
  crud: {
    create: 'Създай',
    viewDetails: 'Виж детайли',
    viewOrEdit: 'Виж или редактирай',
    selected: 'избрани',
    viewUsingVms: 'Виж ВМ, които използват ресурса',
    clearSelection: 'Изчисти избора',
    deleteSelected: 'Изтрий избраните',
    bulkConfirmBody: {
      one: 'Да се изтрие ли {count} избран елемент? Ако е защитен, ще бъде докладван и запазен.',
      other: 'Да се изтрият ли {count} избрани елемента? Защитените ще бъдат докладвани и запазени.'
    },
    bulkDeleted: 'изтрити',
    bulkRefused: 'отказани',
    fieldId: 'ID',
    createdAt: 'Създаден на',
    updatedAt: 'Обновен на',
    immutableField: 'Фиксиран при създаването — контрактът не позволява промяната му',
    immutableScope: 'Скоупът се задава при създаването; някои ресурси се местят със специално действие',
    observedField: 'Наблюдавано състояние — докладвано от платформата, не се редактира'
  }
}
